/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Font_Family_LabelInputs */



/**
* | output |
* | --- |
* | "Font Family" |
*
* @param {Video_Export_Font_Family_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_font_family_label = /** @type {((inputs?: Video_Export_Font_Family_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Font_Family_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Famille de police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftfamilie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Famiglia di caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Семейство шрифтов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Familia de fuentes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体系列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントファミリー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फुहारा परिवार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Família de fontes")
	return /** @type {LocalizedString} */ ("Font Family")
});